import {
  CLEAR_COMMENTS,
  CLEAR_UNREAD_COMMENTS_NUMBER,
  SET_TOTAL_COMMENTS,
  SET_COMMENTS,
  SET_UNREAD_COMMENTS_NUMBER,
  SET_FETCHING_COMMENTS,
} from '../constants/actionTypes';

const initialState = {
  comments: null,
  total: 0,
  numOfUnreadComments: 0,
  isFetching: false,
};

const comments = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMENTS:
      return {...state, comments: action.payload};
    case SET_TOTAL_COMMENTS:
      return {...state, total: action.payload};
    case CLEAR_COMMENTS:
      return initialState;
    case SET_UNREAD_COMMENTS_NUMBER:
      return {...state, numOfUnreadComments: action.payload};
    case CLEAR_UNREAD_COMMENTS_NUMBER:
      return {...state, numOfUnreadComments: 0};
    case SET_FETCHING_COMMENTS:
      return {...state, isFetching: action.payload };
    default:
      return state;
  }
}
  
export default comments;



// WEBPACK FOOTER //
// ./src/reducers/reducer-conversation.js